// B2BFrameworksMenu.js
import React from 'react';
import { AccountTree, AddCircle, Construction, GitHub, Handshake, Info, OutlinedFlag, Sensors, Terminal, ViewList } from '@mui/icons-material';
import CustomMenu from '../layout/components/CustomMenu';
import useMenuItemClick from '../layout/hooks/useMenuItemClick';

const B2BFrameworksMenu = ({ handleLogout, onItemSelected = null }) => {
    const handleItemClick = useMenuItemClick(onItemSelected);

    const menuItems = [
        {
            label: 'Generic Frameworks',
            icon: <AccountTree />,
            b2bProducts: ['B2B_BASE'],
            items: [
                {
                    label: 'Explorer.', icon: <OutlinedFlag />, onClick: () => {
                        handleItemClick('/frameworks/genericfw/explorer');
                    },
                },
                {
                    label: 'List frameworks.', icon: <ViewList />, rolesAllowed: ['ROLE_SUPER_ADMIN'], onClick: () => {
                        handleItemClick('/frameworks/genericfw/list');
                    },
                },
                { label: 'Add new framework.', icon: <AddCircle />, rolesAllowed: ['ROLE_SUPER_ADMIN'], onClick: handleLogout },
            ],
        },
        {
            label: 'IOT Frameworks',
            icon: <Sensors />,
            b2bProducts: ['B2B_BASE', 'B2B_IOT_FW'],
            items: [
                {
                    label: 'Explorer.', icon: <OutlinedFlag />, onClick: () => {
                        handleItemClick('/frameworks/iotfw/explorer');
                    },
                },
                {
                    label: 'List frameworks.', icon: <ViewList />, rolesAllowed: ['ROLE_SUPER_ADMIN'], onClick: () => {
                        handleItemClick('/frameworks/iotfw/list');
                    },
                },
                { label: 'Add new framework.', icon: <AddCircle />, rolesAllowed: ['ROLE_SUPER_ADMIN'], onClick: handleLogout },
            ],
        },
        {
            label: 'Software Frameworks',
            b2bProducts: ['B2B_BASE', 'B2B_SOFTWAREFW'],
            icon: <Terminal />,
            items: [
                {
                    label: 'Explorer.', icon: <OutlinedFlag />, onClick: () => {
                        handleItemClick('/frameworks/software/explorer');
                    },
                },
                {
                    label: 'List frameworks.', rolesAllowed: ['ROLE_SUPER_ADMIN'], icon: <ViewList />, onClick: () => {
                        handleItemClick('/frameworks/software/list');
                    },
                },
                { label: 'Add new framework.', rolesAllowed: ['ROLE_SUPER_ADMIN'], icon: <AddCircle />, onClick: handleLogout },
            ],
        },
        {
            label: 'Partner\'s Frameworks',
            icon: <Handshake />,
            b2bProducts: ['B2B_BASE', 'B2B_PARTNERFW'],
            items: [
                {
                    label: 'Explorer.', icon: <OutlinedFlag />, onClick: () => {
                        handleItemClick('/frameworks/partners/explorer');
                    },
                },
                {
                    label: 'List frameworks.', rolesAllowed: ['ROLE_SUPER_ADMIN'], icon: <ViewList />, onClick: () => {
                        handleItemClick('/frameworks/partners/list');
                    },
                },
                { label: 'Add new framework.', rolesAllowed: ['ROLE_SUPER_ADMIN'], icon: <AddCircle />, onClick: handleLogout },
            ],
        },
        {
            label: 'Cross-Sectoral Frameworks',
            icon: <Construction />,
            b2bProducts: ['B2B_BASE', 'B2B_VERTICALFW'],
            items: [
                {
                    label: 'Explorer.', icon: <OutlinedFlag />, onClick: () => {
                        handleItemClick('/frameworks/vertical/explorer');
                    },
                },
                {
                    label: 'List frameworks.', rolesAllowed: ['ROLE_SUPER_ADMIN'], icon: <ViewList />, onClick: () => {
                        handleItemClick('/frameworks/vertical/list');
                    },
                },
                { label: 'Add new framework.', rolesAllowed: ['ROLE_SUPER_ADMIN'], icon: <AddCircle />, onClick: handleLogout },
            ],
        },
        {
            label: 'GIT Info',
            icon: <GitHub />,
            rolesAllowed: ['ROLE_SUPER_ADMIN'],
            items: [
                {
                    label: 'Generic Frameworks. Show GIT commit info.', icon: <Info />,
                    onClick: () => {
                        handleItemClick('/frameworks/genericfw/git-info');
                    },
                },
                {
                    label: 'IOT Frameworks. Show GIT commit info.', icon: <Info />,
                    onClick: () => {
                        handleItemClick('/frameworks/iotfw/git-info');
                    },
                },
                {
                    label: 'Software Frameworks. Show GIT commit info.', icon: <Info />,
                    onClick: () => {
                        handleItemClick('/frameworks/softwarefw/git-info');
                    },
                },
                {
                    label: 'Partner\'s Frameworks. Show GIT commit info.', icon: <Info />,
                    onClick: () => {
                        handleItemClick('/frameworks/partnerfw/git-info');
                    },
                },
                {
                    label: 'Vertical Frameworks. Show GIT commit info.', icon: <Info />,
                    onClick: () => {
                        handleItemClick('/frameworks/verticalfw/git-info');
                    },
                },
            ],
        },
    ];

    return (
        <CustomMenu title="Frameworks Menu"
            rolesAllowed={null}
            menuItems={menuItems} />
    );
};

export default B2BFrameworksMenu;
